import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import './slide-toggle.scss';

export interface Props extends PropsWithChildren {
  show: boolean;
}

export const SlideToggle = ({ show, children }: Props) => {
  return <div className={classNames('slide-toggle', show && 'show')}>{children}</div>;
};
